import {Component, Input} from "@angular/core";

@Component({
    selector:'thank-you',
    template: require('./thank.you.page.template.html'),
})
export class ThankYouComponent{
    @Input() isError:boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/templates/thank.you.page/thank.you.page.component.ts